export default __webpack_public_path__ + "static/media/eye-purple.6523ccc7.svg";